import React from 'react'
import Header from './component/header/Header'
import About from './component/about/About'
import Experience from './component/experience/Experience'
import Portfolio from './component/portfolio/Portfolio'
import Contact from './component/contact/Contact'
import Footer from './component/footer/Footer'




function App() {
  return (
    <>
     <Header data-aos='fade-in'/>
     <About/>
     <Experience/>
     <Portfolio/>
     <Contact/>
     <Footer/>
    </>
  );
}

export default App;
